export function checkForWrongEventTarget(target, role) {
  // Browsers trigger TWO click events: on the label (or img, td, div, span, b, em tags which are part of the label or wrappers) AND the input.
  // Screenreaders require certain elements to trigger the toggle (and have special behaviors, e.g. VoiceOver checks the input automatically),
  // so the code is only working when ONE event is triggered. The second event would toggle the radio or checkbox again.
  // Therefore we ignore any click event on any element which has NOT the attribute type='checkbox/radio' or role="checkbox/radio".

  // The target for TALKBACK is div.choice-option element and for VOICEOVER the input element.

  return !(['INPUT', 'DIV'].includes(target.tagName.toUpperCase()) && (target.role == role || target.type == role));
}
